import partnerUnderProceedStatuses from '../partner-under-proceed-statuses';
import partnerRatingStatuses from '../partner-rating-statuses';
import menuNames from '../menu-names';
import currencies from '../currencies';

export default {
	BILLING: {
		DECIMAL_PLACES: 2,
		NAV_REPORT_LIMIT: 100000
	},
	MENU_NAMES: menuNames,
	CURRENCIES: currencies,
	TRANSFER_TYPE_INVOICE: 'invoice',
	TRANSFER_TYPES: ['tax', 'salary', 'invoice', 'other'],
	EMAIL_REGEXP: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"!-]{2,})$/i,
	OPTEN_REGEXP: /[^0-9A-Za-záéíóüöúőűÁÉÍÓÜÖÚŐŰ&% ]/g,
	EU_TAXNUM_REGEXP: /^$|(^[a-zA-Z]{2}\d{8}$)/i,
	VAT_FORMATTED_WITH_SYMBOL: /^\d+([\.,]\d{1,2})?%$/,
	EUVAT_REGEXP: /[A-Z]{2}[0-9A-Z]{2,13}/,
	ZIP_CODE_REGEXP: /^$|(^\d{4}$)/i,
	CITY_NAME_REGEXP: /^$|(^[a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ\-]+$)/i,
	FINANCIAL_ACCOUNT_NUMBER_REGEXP: /^\d{8}-\d{8}(-\d{8})?$/,
	NOT_STARTING_ZERO_AMOUNT: /^[1-9]([0-9]|\\s)*$/,
	ONLY_NUMBERS: /^[0-9]+$/,
	// USERNAME_REGEXP_OLD: /^[a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ0-9._]*$/,
	USERNAME_REGEXP: /^[a-zA-Z0-9_]*$/,
	COUPON_REGEXP: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8}$/,
	PICKER_DATE_FORMAT: /^\d{4}.\d{1,2}.\d{1,2}$/,
	QUANTITY_UNIT_REGEXP: /^[a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ][a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ0-9]*$/,
	FORBIDDEN_CHARACTERS_REGEXP: /^[^?'<>()=]+$/,
	PAGE_NUM: 1,
	ROW_NUM: 50,
	COMMENT_NUM: 2,
	HEADERSTATUS: {
		WAITING_FOR_SIGNATURE: 'EBIZ_Signed',
		UNDER_PREPARATION: 'under_preparation',
		WAITING_FOR_MW_SIGNATURE: 'MW_Signed',
		UNDER_TRANSFER: 'MW_GWBSent'
	},
	TRANSFER_SUCCESS_MESSAGE: 'SIKER',
	TRANSFER_SUCCESS_PARKING: 'PARKOLAS',
	TRANSFER_SUCCESS_TANKING: 'TANKOLAS',
	INVOICE_STATUS: {
		IS_PAID: 'Paid',
		PAID: 'paid'
	},
	DEFAULT_VAT_RATE: 27,
	MIDDLEWARE_ERROR: {
		NOT_ENOUGH_SIGN_ON_PACKAGE: 'NEMELEGSEGESALAIRAS',
		NEED_SIGN_ON_PACKAGE: 'ALAIRASSZUKSEGES',
		MESSAGE_TOO_LONG: 'KOZLEMENYHOSSZ',
		MESSAGE_IS_LONGER_THAN_32: 'KOZLEMENYHOSSZ_32'
	},
	// PAYMENT_METHODS: {
	// 	10: 'készpénz',
	// 	30: 'átutalás',
	// 	48: 'bankkártya',
	// 	20: 'csekk',
	// 	'zU': 'utánvét',
	// 	'zG': 'ajándékutalvány',
	// 	'zB': 'barter',
	// 	'49': 'csoportos beszedés',
	// 	'zO': 'OTP Simple',
	// 	'zM': 'kompenzáció',
	// 	'zC': 'kupon',
	// 	'zP': 'PayPal',
	// 	'zS': 'PayU',
	// 	'zK': 'SZÉP Kártya',
	// 	'zV': 'utalvány',
	// 	'zL': 'levonásos'
	// },
	PAYMENT_METHODS: {
		10: {
			hu: 'készpénz',
			en: 'cash',
			de: 'Bargeld'
		},
		30: {
			hu: 'átutalás',
			en: 'transfer',
			de: 'Banküberweisung'
		},
		48: {
			hu: 'bankkártya',
			en: 'bankcard',
			de: 'Bankkarte'
		},
		20: {
			hu: 'csekk',
			en: 'cheque',
			de: 'Scheck'
		},
		'zU': {
			hu: 'utánvét',
			en: 'cash on delivery',
			de: 'Nachnahme'
		},
		'zG': {
			hu: 'ajándékutalvány',
			en: 'gift coupon',
			de: 'Geschenkkarte'
		},
		'zB': {
			hu: 'barter',
			en: 'barter',
			de: 'Tauschhandel'
		},
		'49': {
			hu: 'csoportos beszedés',
			en: 'direct debit',
			de: 'Inkassoauftrag'
		},
		'zO': {
			hu: 'OTP Simple',
			en: 'OTP Simple',
			de: 'OTP Simple'
		},
		'zM': {
			hu: 'kompenzáció',
			en: 'compensation',
			de: 'Kompensation'
		},
		'zC': {
			hu: 'kupon',
			en: 'Coupon',
			de: 'Gutschein'
		},
		'zP': {
			hu: 'PayPal',
			en: 'PayPal',
			de: 'PayPal'
		},
		'zS': {
			hu: 'PayU',
			en: 'PayU',
			de: 'PayU'
		},
		'zK': {
			hu: 'SZÉP Kártya',
			en: 'SZÉP card',
			de: 'SZÉP Karte'
		},
		'zV': {
			hu: 'utalvány',
			en: 'voucher',
			de: 'Voucher'
		},
		'zL': {
			hu: 'levonásos',
			en: 'substraction',
			de: 'levonásos'
		},
		'zE': {
			hu: 'Egészségpénztári kártya',
			en: 'Health insurance card',
			de: 'Gesundheitskarte'
		}
	},
	CUSTOM_EBIZ_GROUP_NAME: 'ebiz_grp_custom',
	EBIZ_SUPER_USER_GROUP_NAME: 'ebiz_grp_comp_admin',
	EBIZ_SUPPORT_GROUP_NAME: 'ebiz_grp_support',
	CALCULABLE_DISTRICT_CITY_NAMES: ['Budapest'],
	PAYMENT_MODES: {
		CASH: 10,
		TRANSFER: 30,
		BANK_CARD: 40
	},
	FIVE_MB_IN_BYTES: 5242880,
	ERRORS: {
		EMPTY: 'empty'
	},
	EBIZ_FIRM_TYPE: 'ebiz',
	MAIL_FOLDER_INCOMING: 'income',
	MAIL_FOLDER_ACCEPTED: 'accepted',
	DATEFORMAT: {
		languages: {
			hu: {
				default: 'YYYY. MM. DD.',
				accountancy: 'YYYY-MM-DD',
				billing: 'YYYY.MM.DD.',
				ui: 'yyyy.MM.dd.',
				log: 'YYYY. MM. DD. - HH:mm',
				payment: 'YYYY. MM. DD. HH:mm:ss',
				invoceCreated: 'YYYY. MMMM DD. - h:mm'
			},
			en: {
				default: 'MM. DD. YYYY',
				accountancy: 'YYYY-MM-DD',
				billing: 'YYYY-MM-DD',
				ui: 'MM.dd.yyyy',
				log: 'MM. DD. YYYY. - HH:mm',
				payment: 'YYYY. MM. DD. HH:mm:ss',
				invoceCreated: 'MMMM. Do YYYY., - h:mm'
			}
		},
		alt_input_formats: {
			default: ['YYYY-MM-DD'],
			ui: ['yyyy-MM-dd', 'yyyy.MM.dd.']
		},
		formatDay: 'd'
	},
	INVOICE_ARRIVED_NOTIFICATION_CODE: 'IINV1',
	EBIZ_PACKAGE_S: 'ebiz_ef_s',
	EBIZ_PACKAGE_M: 'ebiz_ef_m',
	EBIZ_PACKAGE_XL: 'ebiz_ef_xl',
	EBIZ_PACKAGE_SUSPENDED: 'ebiz_ef_suspended',
	CURRENCY: {
		HUF: 'HUF',
		EUR: 'EUR',
		USD: 'USD'
	},
	LANGUAGE_CODES: {
		HUN: 'HUN'
	},
	INVOICE_TYPE: {
		E_INVOICE: 'e-invoice',
		PAPER_INVOICE: 'paper-invoice'
	},
	INVOICE_TRANSACTION_STATUS: [
		{
			id: 'MultipleTransaction',
			hu: 'Egyéb fizetés',
			en: 'Other'
		},
		{
			id: 'OTPBankTransaction',
			hu: 'OTP-s átutalás',
			en: 'OTP transaction'
		},
		{
			id: 'OtherBankTransaction',
			hu: 'nem OTP-s átutalás',
			en: 'Other transaction'
		},
		{
			id: 'CashTransaction',
			hu: 'Készpénzes fizetés',
			en: 'Cash payment'
		},
		{
			id: 'GiftCardTransaction',
			hu: 'Ajándékutalvány',
			en: 'Gift card'
		},
		{
			id: 'CardTransaction',
			hu: 'Bankkártyás fizetés',
			en: 'Bank card'
		},
		{
			id: 'CheckTransaction',
			hu: 'Csekk',
			en: 'Cheque'
		},
		{
			id: 'CollectOnDeliveryTransaction',
			hu: 'Utánvét',
			en: 'Cash on delivery'
		},
		{
			id: 'BarterTransaction',
			hu: 'Barter',
			en: 'Barter'
		},
		{
			id: 'DirectDebitTransaction',
			hu: 'Csoportos beszedés',
			en: 'Direct debit'
		},
		{
			id: 'OTPSimpleTransaction',
			hu: 'OTP Simple',
			en: 'OTP simple'
		},
		{
			id: 'CompensationTransaction',
			hu: 'Kompenzáció',
			en: 'Compensation'
		},
		{
			id: 'CouponTransaction',
			hu: 'Kupon',
			en: 'Coupon'
		},

		{
			id: 'PayPalTransaction',
			hu: 'PayPal',
			en: 'PayPal'
		},
		{
			id: 'PayUTransaction',
			hu: 'PayU',
			en: 'PayU'
		},
		{
			id: 'SZEPCardTransaction',
			hu: 'SZÉP Kártya',
			en: 'SZÉP card'
		},
		{
			id: 'VoucherTransaction',
			hu: 'Utalvány',
			en: 'Voucher'
		},
		{
			id: 'LiabilitiesTransaction',
			hu: 'Behajthatatlan követelés',
			en: 'Non-collectable accounts receivable'
		},
		{
			id: 'OtherTransaction',
			hu: 'Egyéb fizetés',
			en: 'Other payment'
		},
		{
			id: 'NoTransaction',
			hu: '',
			en: ''
		},
		{
			id: 'StornoInvoice',
			hu: 'Sztornó számla',
			en: 'Storno invoice'
		},
		{
			id: 'ManualStornoTransaction',
			hu: 'Sztornó számla',
			en: 'Storno invoice'
		},
		{
			id: 'ReductionTransaction',
			hu: 'Levonásos',
			en: 'Substraction'
		},
		{
			id: 'HealthInsuranceCardTransaction',
			hu: 'Egészségpénztári kártya',
			en: 'Health insurance card'
		}

	],
	INVOICE_ICONS: {
		OK: 'ok icon-ok',
		CALENDAR: 'waiting icon-calendar',
		WARNING: 'warning icon-warning',
		STORNO: 'storno icon-storno',
		STORNO_CANCEL: 'cancelled icon-storno',
		CANCEL: 'cancelled icon-x-circle',
		DELETED: 'deleted icon-x-circle'
	},
	INVOICE_DETAILS: {
		STATUS: {
			PAID: 'Paid',
			PAYABLE: 'Payable',
			EXPIRED: 'Expired'
		},
		TYPE: {
			STORNOINVOICE: 'StornoInvoice',
			DELETEDINVOICE: 'DeletedInvoice',
			DELETEDPROFORMA: 'DeletedProforma',
			FINISHEDPROFORMA: 'FinishedProforma',
			PREPAYMENTINVOICESTORNO: 'PrepaymentInvoiceStorno',
			FINALINVOICESTORNO: 'FinalInvoiceStorno',
			FINALINVOICE: 'FinalInvoice'
		}
	},
	INVOICE_DOCID_MAXLENGTH: 32,
	RELATIONSHIP_ID_KEY: 'relId',
	EXIT: 'x',
	INVOICE_MENU_OPERATIONS: {
		STORNO: 'storno',
		NEW_INVOICE: 'newInvoice',
		NEW_PROFORMA: 'newProforma',
		NEW_INVOICE_FROM_PROFORMA: 'newInvoiceFromProforma',
		DELETE_PROFORMA: 'deleteProforma',
		EDIT: 'edit',
		DELETE: 'delete'
	},

	INVOICE_DELIVERY: {
		DATEFORMAT: 'yyyy-MMMM-dd - HH:mm',
		STATUS: {
			PAYMENT_REMINDER: 10,
			SEND_INVOICE: 20
		}
	},
	PARTNER_UNDER_PROCEED_STATUSES: partnerUnderProceedStatuses,
	PARTNER_RATING_STATUSES: partnerRatingStatuses,
	BIG_ZIP_DONE_CODE: 'BK5',
	NAV_ZIP_DONE_CODE: 'NAV2',
	IS_EBIZ_PARTNER: '1',
	COUNTRIES: {
		HU: 'HU'
	},
	BUDAPEST_START_ZIPCODE: '1',
	TRANSACTION_STATE_TRANSFERRED: 'transferred',
	TRANSACTION_STATE_UNDER_PREPARATION: 'under_preparation',
	TRANSACTION_STATE_WAITING_FOR_SIGNATURE: 'waiting_for_signature',
	DEFAULT_INVOICE_LANGUAGE: 'hu',
	TRANSACTION_FILTER_STORE_NAME: 'TransactionFilterStore',
	BILLING_PAGE_STORE: 'BillingPageMemoryStore',
	USER_CANNOT_DELETE_ACCOUNT_SERVER_STATUS: 400,
	DELETE_USER_OR_COMPANY_REST_TYPES: {
		DELETE_COMPANY: 'userCompanyDelete',
		DELETE_USER: 'deleteUserAccount'
	},
	INBOX: {
		DEFAULT_DOCTYPE_FILTER: 'n/a,_incoming_invoice_ubl2.1,_incoming_proforma_ubl2.1,ebiz_invoice,ebiz_handmade_document_out,ebiz_handmade_document_in,ebiz_proforma_out,ebiz_proforma_in'
	},
	DEFAULT_DAYS_TO_ADD: {
		FIRST: 8,
		SECOND: 15,
		THIRD: 30
	},
	DISCLAIMER_CLASSES: {
		BANK_CONNECTION: 'icon-bank-account-disclaimer',
		LOGO: 'icon-onboarding-add-user',
		SUBSCRIPTION: 'icon-bank-account-disclaimer',
		WARNING: 'icon-warning'
	},
	EU_COUNTRIES: ["HU", "AT", "BE", "BG", "CY", "CZ", "DK", "EE", "FI", "FR", "GR", "NL",
		"HR", "IE", "PL", "LV", "LT", "LU", "MT", "DE", "IT", "PT", "RO", "ES", "SE", "SK", "SI"],
	TAX_NUMBER_COMMUNAL_REGEX: /^[A-Z]{2}[A-Z0-9]{2,13}$/g
};
